/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/15/21
 */

import {errorExchange} from "urql";
import { toast } from "react-toastify";

export default function getErrorExchange() {
	return errorExchange({
		onError: error => {
			const message = error.networkError ? "Network error: make sure you are connected to Atlassian VPN" : error.message;
			toast.error(message);
			console.error(error.message);
			const isAuthError = error.graphQLErrors.some(e => e.extensions?.code === 'FORBIDDEN');
			if (isAuthError) {

			}
		},
	})
}